module.exports = __webpack_public_path__ + "static/media/button_arrow_left.74d0bf4c.svg";